import { render, staticRenderFns } from "./Remember.vue?vue&type=template&id=00f37b36&scoped=true&"
import script from "./Remember.vue?vue&type=script&lang=js&"
export * from "./Remember.vue?vue&type=script&lang=js&"
import style0 from "./Remember.vue?vue&type=style&index=0&id=00f37b36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f37b36",
  null
  
)

export default component.exports